var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { s as size, _ as __spreadValues } from "./chunk-JJ6VZ5V7-350b4003.mjs";
import * as React from "react";
import { s as styled, c as color } from "./lib-42970741.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var SvgComponent = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M2.258 27.333h27.484a9.16 9.16 0 0 1-2.034 2.267H4.292a9.161 9.161 0 0 1-2.034-2.267Zm-1.69-4.555H31.42c-.085.449-.181.898-.288 1.346 0 0-.075.36-.273.92H1.14c-.198-.56-.274-.92-.274-.92a26.337 26.337 0 0 1-.298-1.346Zm-.529-4.556h31.917c-.037.74-.098 1.499-.187 2.267H.217a33.593 33.593 0 0 1-.178-2.267Zm31.918-4.555c.038.798.05 1.579.04 2.333H16v-2.333h15.957Zm-.53-4.556c.146.757.26 1.515.346 2.267H16V9.11h15.427Zm-1.746-4.555c.555.834.922 1.649 1.152 2.266H16V4.556h13.681Zm-2.159-2.289H16V0c3.75.033 7.567.432 9.69 1.263.69.268 1.298.612 1.832 1.004Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M16 0v16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M9.498 4.29a4 4 0 1 0 0 7.42 4.667 4.667 0 1 1 0-7.42Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M10.617 6.382 11 5l.383 1.382.967-1.078-.271 1.375 1.314-.567-.861 1.16L14 7.325 12.704 8 14 8.675l-1.468.053.86 1.16-1.313-.567.27 1.375-.966-1.078L11 11l-.383-1.382-.967 1.078.271-1.375-1.314.567.861-1.16L8 8.675 9.296 8 8 7.325l1.468-.053-.86-1.16 1.313.567-.27-1.375.966 1.078Z",
      clipRule: "evenodd"
    }
  )
), "SvgComponent"), SvgFlagMys = styled(SvgComponent)`
  ${size}
  ${color}
`, FlagMys_default = SvgFlagMys;
export {
  FlagMys_default as default
};
